import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import { computed, onMounted, reactive, ref, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { USERINFO } from "@/store/mutation-types";
import apis from "@/api";
import dayjs from "dayjs";
import AddAside from "../components/AddAside";
import common from "../composables/common";
import IopEvent from "../components/IopEvent";
import OfferRefDemandDialog from "@/views/Home/MyNeeds/components/OfferRefDemandDialog";
import SensitiveWords from "../components/SensitiveWords";
export default {
  name: "Index",
  components: {
    SensitiveWords,
    OfferRefDemandDialog,
    IopEvent,
    AddAside
  },
  setup(props, ctx) {
    const {
      commonData,
      smsProcs,
      disabledDate
    } = common();
    const router = useRouter();
    const route = useRoute();
    const formRef = ref(null);
    const data = reactive({
      sensWords: {},
      sensChecked: false,
      belongDepart: 'jike',
      offerDemandVisible: false,
      smsTypes: [],
      offerIds: [],
      inputVisible: false,
      inputValue: '',
      demand: {},
      assetsId: '',
      demandId: route.query.demandId,
      editType: route.query.editType,
      rules: {
        name: [{
          required: true,
          message: "请输入需求名称",
          trigger: "blur"
        }, {
          validator: validateName,
          trigger: 'blur'
        }],
        validDate: [{
          required: true,
          message: "请选择短信有效期",
          trigger: "blur"
        }],
        remark: [{
          required: true,
          message: "请输入需求内容",
          trigger: "blur"
        }],
        smsType: [{
          required: true,
          message: "请选择IOP短信发送渠道",
          trigger: "blur"
        }],
        smsContent: [{
          required: true,
          message: "请输入短信内容",
          trigger: "blur"
        }],
        iopEvent: [{
          validator: validIopEvents,
          trigger: 'blur'
        }]
      },
      fileList: []
    });
    function validIopEvents(rule, value, callback) {
      if (data.demand.smsType === 'RTFLOW' || data.demand.smsType === 'EC10001') {
        if (data.demand.positionId) {
          callback();
        } else {
          callback(new Error('请选择IOP事件'));
        }
      } else {
        data.demand.positionId = data.demand.smsType;
        callback();
      }
    }
    function validateName(rule, value, callback) {
      if (data.editType == 1 && value) {
        apis.checkDemandName({
          demandName: value
        }).then(res => {
          if (res.success) {
            if (res.data) {
              callback(new Error('需求名称已存在'));
            } else {
              callback();
            }
          } else {
            callback(new Error(res.msg));
          }
        });
      } else {
        callback();
      }
    }
    const handleClose = offerId => {
      data.offerIds.splice(data.offerIds.indexOf(offerId), 1);
    };
    const showInput = () => {
      data.inputVisible = true;
    };
    const handleInputConfirm = () => {
      if (data.inputValue) {
        data.offerIds.push(data.inputValue);
      }
      data.inputVisible = false;
      data.inputValue = '';
    };
    const handleRemove = (file, fileList) => {
      console.log('handleRemove');
      console.log(file, fileList);
      data.fileList = fileList;
    };
    const handlePreview = file => {
      console.log('handlePreview');
      console.log(file);
    };
    const handleExceed = (files, fileList) => {
      ElMessage.error(`最多上传5个附件`);
    };
    const fileUpload = params => {
      const formData = new FormData();
      formData.append('fileList', params.file);
      formData.append("demandId", data.demand.id);
      formData.append("demandName", data.demand.name);
      apis.upload(formData).then(res => {
        console.log("res: ", res);
        if (res.success && res.data && res.data.length > 0) {
          res.data.forEach(file => {
            data.fileList.push({
              name: file.fileName,
              url: file.innerUrl,
              fileName: file.fileName,
              fileUrl: file.innerUrl,
              fileId: file.id
            });
          });
        }
      });
    };
    const handleSubmit = state => {
      data.demand.remark = data.demand.smsContent;
      formRef.value.validate(valid => {
        if (valid) {
          const userInfo = JSON.parse(window.localStorage.getItem(USERINFO));
          data.demand.offerIds = data.offerIds.join(",");
          data.demand.type = 1;
          data.demand.belongDepart = data.belongDepart;
          data.demand.state = state;
          data.demand.phone = userInfo.mobile;
          data.demand.createrDepName = userInfo.depName;
          data.demand.validDateBgn = dayjs(data.demand.validDate[0]).format("YYYY-MM-DD HH:mm:ss");
          data.demand.validDateEnd = dayjs(data.demand.validDate[1]).format("YYYY-MM-DD HH:mm:ss");
          // 复制
          if (data.editType == 1) {
            data.demandId = '';
          }
          if (data.demandId) {
            apis.editDemand(data.demand).then(res => {
              if (res.success) {
                data.demand = res.data;
                uploadAttachments();
                saveAsws(data.assetsId);
              } else {
                ElMessage.error(res.msg);
              }
            });
          } else {
            apis.addDemand(data.demand).then(res => {
              if (res.success) {
                data.demand = res.data;
                saveAsws(res.data.smsSrcId);
                uploadAttachments();
              } else {
                ElMessage.error(res.msg);
              }
            });
          }
        }
      });
    };
    const saveAsws = assetsId => {
      data.sensWords.assetsId = assetsId;
      apis.saveAsws([data.sensWords]);
    };
    const uploadAttachments = () => {
      if (data.fileList.length > 0) {
        data.fileList.forEach(f => {
          f.demandId = data.demand.id;
        });
        apis.addAttachments(data.fileList).then(res => {
          if (res.success) {
            router.push("/my-needs/list");
          }
        });
      } else {
        router.push("/my-needs/list");
      }
    };
    const loadDemand = () => {
      apis.getDemandById({
        id: data.demandId
      }).then(res => {
        if (res.success) {
          data.demand = res.data;
          const validDate = [res.data.validDateBgn, res.data.validDateEnd];
          data.demand.validDate = validDate;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const userInfo = computed(() => {
      const userInfo = window.localStorage.getItem(USERINFO);
      if (data.demand && data.demand.belongDepart) {} else {
        const depName = userInfo.depName;
        if (depName && depName.includes(commonData.belongDeparts[0].name)) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          data.belongDepart = commonData.belongDeparts[0].code;
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          data.belongDepart = commonData.belongDeparts[1].code;
        }
      }
      return JSON.parse(userInfo);
    });
    const initSmsType = () => {
      apis.queryPositionTree('sms').then(res => {
        if (res.success) {
          const types = res.data[0].children;
          sortChinese(types, 'nodeName');
          data.smsTypes = types;
          if (!data.demand.smsType) {
            data.demand.smsType = '100069';
          }
        }
      });
    };
    function sortChinese(arr, dataLeven) {
      // 参数：arr 排序的数组; dataLeven 数组内的需要比较的元素属性
      /* 获取数组元素内需要比较的值 */
      function getValue(option) {
        // 参数： option 数组元素
        if (!dataLeven) return option;
        var data = option;
        dataLeven.split('.').filter(function (item) {
          data = data[item];
        });
        return data + '';
      }
      arr.sort(function (item1, item2) {
        return getValue(item1).localeCompare(getValue(item2), 'zh-CN');
      });
    }
    const loadSmsAssets = () => {
      apis.getSmsById({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          data.demand.smsContent = res.data.content;
          data.demand.positionId = res.data.positionId;
          data.offerIds = res.data.offerIds ? res.data.offerIds.split(",") : [];
          data.belongDepart = res.data.belongDepart;
          data.assetsId = res.data.srcId;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const loadDemandAttachs = () => {
      apis.getAttachments({
        demandId: data.demandId
      }).then(res => {
        if (res.success) {
          data.fileList = res.data;
          data.fileList.forEach(f => {
            f.name = f.fileName;
            f.url = f.fileUrl;
          });
        }
      });
    };
    const smsTypeChange = () => {
      data.demand.positionId = '';
    };
    const belongDepartChange = val => {
      data.demand.belongDepart = val;
      if (val === commonData.belongDeparts[0].code) {
        data.demand.smsType = '10088ZQ';
      } else {
        data.demand.smsType = '100069';
      }
    };
    const getDisabled = computed(() => typeId => {
      const bd = data.belongDepart === commonData.belongDeparts[0].code;
      const ti = typeId === '10088ZQ' || typeId === '10086ZQ';
      return !(bd ^ ti);
    });
    const checkSensWord = () => {
      data.sensChecked = false;
      const {
        name,
        smsContent
      } = data.demand;
      const sw = {
        assetsContent: smsContent,
        assetsName: '短信-' + name
      };
      apis.checkSensitive(sw).then(res => {
        if (res.code == 200) {
          console.log(res.data);
          data.sensWords = res.data;
        }
      }).finally(() => {
        data.sensChecked = true;
      });
    };
    onMounted(() => {
      if (data.demandId) {
        loadDemand();
        loadSmsAssets();
        loadDemandAttachs();
      } else {
        const validDate = [dayjs().set('hour', 0).set('minute', 0).set('second', 0), dayjs().add(1, 'year').set('hour', 23).set('minute', 59).set('second', 59)];
        data.demand.validDate = validDate;
      }
      initSmsType();
    });
    return {
      ...toRefs(data),
      ...toRefs(commonData),
      userInfo,
      formRef,
      smsProcs,
      handleSubmit,
      disabledDate,
      handleRemove,
      handlePreview,
      handleExceed,
      fileUpload,
      smsTypeChange,
      belongDepartChange,
      handleClose,
      handleInputConfirm,
      showInput,
      getDisabled,
      checkSensWord
    };
  }
};